'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _browser = require('@sentry/browser');

var Sentry = _interopRequireWildcard(_browser);

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Sentry.init({
  dsn: 'https://f17bf8711e7c4a56997b6b90835b3a4d@sentry.io/1807704',
  defaultIntegrations: false
});

var handleError = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
    var error = _ref2.error,
        type = _ref2.type,
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data;

    var _window$prg$customer, id, email, _window$prg$request, host, locale, page_type, path, template, country;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _window$prg$customer = window.prg.customer, id = _window$prg$customer.id, email = _window$prg$customer.email;
            _window$prg$request = window.prg.request, host = _window$prg$request.host, locale = _window$prg$request.locale, page_type = _window$prg$request.page_type, path = _window$prg$request.path;
            template = window.prg.template.path;
            _context.next = 5;
            return _Flow2.default.getCountry();

          case 5:
            country = _context.sent;


            Sentry.configureScope(function (scope) {
              return scope.setUser({ id: id, email: email });
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('type', type);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('host', host);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('locale', locale);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('page_type', page_type);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('path', path);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('template', template);
            });
            Sentry.configureScope(function (scope) {
              return scope.setTag('country', country);
            });
            Sentry.configureScope(function (scope) {
              return scope.setExtra('data', JSON.stringify(data));
            });

            Sentry.captureException(error);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function handleError(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = {
  handle: handleError
};